import type { CountryCode } from '@/graphql/saleor/api';
import { BASE_STORE_FINDER_URL } from '@/lib/const';

export const navToFindStores = (locale: string, code: CountryCode) => {
  if (!locale) return '';

  const langOfLocale = locale.split('-')[1];
  if (langOfLocale === 'zht') {
    return `${BASE_STORE_FINDER_URL}zh_hant?country=${code}`;
  }
  if (langOfLocale === 'zh') {
    return `${BASE_STORE_FINDER_URL}zh_hans?country=${code}`;
  }
  const path = `/${locale}/stores`;
  return path;
};
